// extracted by mini-css-extract-plugin
module.exports = {"accordion":"styles_accordion__sMaea","item":"styles_item__niCEm","title":"styles_title__l83wh","content":"styles_content__HO8ol"};